var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 8.48663L26.0402 25.8333H5.96016L16.0002 8.48663ZM16.0002 3.16663L1.3335 28.5H30.6668L16.0002 3.16663ZM17.3335 21.8333H14.6668V24.5H17.3335V21.8333ZM17.3335 13.8333H14.6668V19.1666H17.3335V13.8333Z",
    fill: "#192BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssue);
export default __webpack_public_path__ + "static/media/ReportIssue.5dba0e3108db7e0bdafaab557dcbb28b.svg";
export { ForwardRef as ReactComponent };